module.exports = __webpack_public_path__ + "img/t2-c27.c27d0879.png";